'use client';

import { useSyncExternalStore } from 'react';
export const usePrefersReducedTransparency = () => {
  const getPrefersReducedTransparency = _temp;
  return useSyncExternalStore(_temp2, getPrefersReducedTransparency, _temp3);
};
function _temp() {
  return typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-transparency: reduce)").matches : false;
}
function _temp2(callback) {
  const mediaQuery = window.matchMedia("(prefers-reduced-transparency: reduce)");
  mediaQuery.addEventListener("change", callback);
  return () => mediaQuery.removeEventListener("change", callback);
}
function _temp3() {
  return false;
}